/* =========================================================
   LA New Guest — Add To Cart Button 
   - Adds configured variant to cart
   - Fetches cart + dispatches Pipeline cart change with detail.cart
   - Opens Pipeline cart drawer/popdown if possible
   - Falls back to /cart
========================================================= */

(function () {
  function openPipelineCartUI(cart) {
    try {
      // Dispatch change event WITH cart detail (Pipeline-friendly)
      if (cart) {
        document.dispatchEvent(
          new CustomEvent('theme:cart:change', { bubbles: true, detail: { cart: cart } })
        );
      } else {
        document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true }));
      }

      // Try opening cart via Pipeline event
      document.dispatchEvent(new CustomEvent('theme:cart:open', { bubbles: true }));

      // Legacy / alternate listeners (harmless fallbacks)
      document.dispatchEvent(new CustomEvent('cart:open'));
      document.dispatchEvent(new CustomEvent('ajaxCart:open'));
    } catch (e) {}

    // DOM fallback: click theme cart trigger
    var cartTrigger =
      document.querySelector('[data-cart-toggle]') ||
      document.querySelector('[data-drawer-toggle="cart"]') ||
      document.querySelector('[aria-controls*="cart"]') ||
      document.querySelector('.site-nav__cart') ||
      document.querySelector('a[href="/cart"]');

    if (cartTrigger) {
      cartTrigger.click();
      return true;
    }

    return false;
  }

  function handleATCClick(e) {
    var btn = e.target.closest('[data-la-new-guest-atc]');
    if (!btn) return;

    e.preventDefault();

    var variantId = btn.getAttribute('data-variant-id');
    var qty = parseInt(btn.getAttribute('data-qty') || '1', 10);

    if (!variantId || variantId === 'REPLACE_VARIANT_ID') {
      console.warn('[LA New Guest] Missing variant ID on button.', btn);
      return;
    }

    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: qty
      })
    })
      .then(function (res) {
        // Better debug if it fails
        if (!res.ok) {
          return res.json().catch(function(){ return {}; }).then(function(data){
            console.error('[LA New Guest] Add failed:', res.status, data);
            throw new Error('Add to cart failed');
          });
        }
        return res.json();
      })
      .then(function () {
        // Fetch actual cart object so Pipeline can refresh drawer content
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .catch(function () { return null; });
      })
      .then(function (cart) {
        var opened = openPipelineCartUI(cart);
        if (!opened) window.location.href = '/cart';
      })
      .catch(function (err) {
        console.error('[LA New Guest] ATC error:', err);
      })
      .finally(function () {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('click', handleATCClick);
})();